import {Button} from 'react-bootstrap'
import {NodeOneDispatch} from '../../graphql/types/despachoTypes'
import {parsePrice} from '../../helpers'
import moment from 'moment'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

interface IBtnProps {
  dispatch: NodeOneDispatch
  idFact: string
}

export const ButtonPOS: React.FC<IBtnProps> = ({dispatch, idFact}) => {
  const getTotalPaid = () => {
    let tot = 0
    dispatch.dispatchproductthroughSet.edges.forEach((prod) => {
      tot +=
        (Number(prod.node.product.unitPrice) - Number(prod.node.product.promotion)) *
        prod.node.quantityDispatch
    })
    return `${tot}`
  }

  const htmlRender = `
		<!DOCTYPE html>
<html>

<head>
    <style>
        body {
            font-family: Arial, sans-serif;
            font-size: 13px;
        }

        .receipt {
            max-width: 300px;
            margin: 0 auto;
        }

        .header {
            text-align: center;
        }

        .image {
            max-width: 120px;
        }

        .info-company {
            display: flex;
            flex-direction: column;
            gap: 2px;
        }

        .info-company p {
            padding: 0;
            margin: 0;
        }

        .details {
            margin-top: 20px;
        }

        .footer {
            text-align: center;
            margin-top: 24px;
            border-top: 1px solid;
            
        }

        .line_firma {
            padding-top: 10px;
        }

        .table {
            width: 100%;
            border-collapse: collapse;
        }

        .table,
        td,
        tr,
        th {
            text-align: center;
        }

        .table tr {
            border-bottom: 1px solid rgb(164, 164, 164);
        }

        .table thead {
            border-bottom: 2px solid black;
        }

        .table th {
            padding-bottom: 5px;
        }

        .table td {
            padding: 4px 0px;
        }

        .table tfoot tr {
            border-bottom: 0px;
        }

        tfoot tr td:first-child {
            text-align: right;
            padding-right: 10px;
            font-weight: bolder;
            text-transform: uppercase;
        }

        .forma-pago {
            width: 80%;
            margin: 0 auto;
        }
    </style>
</head>

<body>
    <div class="receipt">
        <div class="header">
            <img src=${toAbsoluteUrl(
              '/yunga-logo.jpg'
            )} alt='logo yunga' width="120" class="image" />
            <h1 style="margin: 6px auto;">CANTERA LA YUNGA</h1>
            <div class="info-company">
                <p>
                    <strong>TÍTULO MINERO AJD 121</strong>
                </p>
                <p>
                    <strong>VEREDA LA YUNGA MUNICIPIO DE POPAYÁN</strong>
                </p>
                <p>
                    <strong>Cel:</strong> 312 7461833 - <span style="display: inline-flex">313 6103014 <svg xmlns="http://www.w3.org/2000/svg" width="14"
                        height="14" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);transform: ;msFilter:;">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M18.403 5.633A8.919 8.919 0 0 0 12.053 3c-4.948 0-8.976 4.027-8.978 8.977 0 1.582.413 3.126 1.198 4.488L3 21.116l4.759-1.249a8.981 8.981 0 0 0 4.29 1.093h.004c4.947 0 8.975-4.027 8.977-8.977a8.926 8.926 0 0 0-2.627-6.35m-6.35 13.812h-.003a7.446 7.446 0 0 1-3.798-1.041l-.272-.162-2.824.741.753-2.753-.177-.282a7.448 7.448 0 0 1-1.141-3.971c.002-4.114 3.349-7.461 7.465-7.461a7.413 7.413 0 0 1 5.275 2.188 7.42 7.42 0 0 1 2.183 5.279c-.002 4.114-3.349 7.462-7.461 7.462m4.093-5.589c-.225-.113-1.327-.655-1.533-.73-.205-.075-.354-.112-.504.112s-.58.729-.711.879-.262.168-.486.056-.947-.349-1.804-1.113c-.667-.595-1.117-1.329-1.248-1.554s-.014-.346.099-.458c.101-.1.224-.262.336-.393.112-.131.149-.224.224-.374s.038-.281-.019-.393c-.056-.113-.505-1.217-.692-1.666-.181-.435-.366-.377-.504-.383a9.65 9.65 0 0 0-.429-.008.826.826 0 0 0-.599.28c-.206.225-.785.767-.785 1.871s.804 2.171.916 2.321c.112.15 1.582 2.415 3.832 3.387.536.231.954.369 1.279.473.537.171 1.026.146 1.413.089.431-.064 1.327-.542 1.514-1.066.187-.524.187-.973.131-1.067-.056-.094-.207-.151-.43-.263">
                        </path>
                    </svg>
                    </span>
                </p>
            </div>
        </div>
        <hr>
        <div class="details">
            <p style="padding-left: 20px; font-size:14px"><strong>Orden pedido:</strong>
                <span style="text-decoration: underline;">${dispatch.invoiceId}</span>
            </p>
            <div style="display: flex; align-items: center; justify-content: space-between; gap: 8px">
                <p>
                    <strong>Fecha:</strong> ${moment(dispatch.departureDatetime).format(
                      'DD MMM [de] YYYY'
                    )}
                </p>
                <p><strong>Hora:</strong> ${moment(dispatch.departureDatetime).format(
                  'hh:mm A'
                )}</p>
            </div>

            <p style='margin-bottom: 0px'><strong>Señor(a):</strong>
                ${dispatch.sale.client.name}
            </p>

            <p><strong>PLACA VOLQUETA:</strong> <span style="text-transform: uppercase">${
              dispatch.plate
            }</span></p>

        </div>

        <table class="table">
            <thead>
                <tr>
                    <th>Item</th>
                    <th>Descripción</th>
                    <th>Cant.</th>
                    <th>Vlr Unit</th>
                    <th>Vlr total</th>
                </tr>
            </thead>
            <tbody>
                ${dispatch.dispatchproductthroughSet.edges
                  .map(
                    (inf, idx) => `
                    <tr style="font-size: 15px;">
                      <td>${idx + 1}</td>
                      <td>${inf.node.product.name}</td>
                      <td>${inf.node.quantityDispatch}</td>
                      <td style="font-size: 15px; font-weight: 500;">${parsePrice(
                        `${Number(inf.node.product.unitPrice) - Number(inf.node.product.promotion)}`
                      )}</td>
                      <td style="font-size: 17px; font-weight: 700; padding-left: 3px;">${parsePrice(
                        `${
                          Number(inf.node.quantityDispatch) *
                          (Number(inf.node.product.unitPrice) - Number(inf.node.product.promotion))
                        }`
                      )}</td>
                    </tr>
                  `
                  )
                  .join('')}
            </tbody>
            <tfoot>
                <tr style="font-size: 15px;">
                    <td colspan="4">Total</td>
                    <td style="font-size: 17px; font-weight: 700;">${parsePrice(
                      getTotalPaid()
                    )}</td>
                </tr>
            </tfoot>
        </table>

        <p><strong>OBSERVACIONES:</strong></p>
        <div class="forma-pago">
            <p>
                <span style="min-width: 18ch; display: inline-block; border-bottom: 1px solid; text-align: center; font-size: 14px;">${
                  dispatch.observations || 'No registra'
                }</span>
            </p>

        </div>
        <div class="footer">
            <p><strong>Firma del Cliente:</strong></p>
            <p class="line_firma">___________________________________</p>
            <p><span style="font-weight: 800;">*****</span> GRACIAS POR SU COMPRA
            <span style="font-weight: 800;">*****</span></p>
        </div>
    </div>
</body>

</html>
	`
  return (
    <Button
      variant='dark'
      onClick={() => {
        const newWindow = window.open('', '', 'width=800,height=800')
        if (!newWindow) return
        newWindow.document.open()
        newWindow.document.write(htmlRender)
        newWindow.document.close()
        newWindow.onload = window.print
      }}
    >
      <i className='bi bi-receipt-cutoff fs-1' />
      Recibo POS
    </Button>
  )
}
